module.exports = __webpack_public_path__ + "media/קטן.a78b662c.mp3";